import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState as rootState,
} from '../../../utils/redux';
import { APPOINTMENT_PROGRESS_TYPES } from '../progress-types';

export const consts = createReqConsts(
  'appointment-form',
  'available-eir-slots-request',
);

export const actions = createActions(consts);

const defaultRequestReducer = createReqReducer(consts);

const initialState = {
  ...rootState,
};

export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'appointments',
    'eir_urgent_care',
    'slots',
    {
      type: 'payload.query',
      queryParameter: 'organization_id',
      selector: 'organizationId',
    },
    {
      type: 'payload.query',
      queryParameter: 'visit_type_id',
      selector: 'visitTypeId',
    },
    {
      type: 'payload.query',
      queryParameter: 'service_id',
      selector: 'serviceId',
    },
    {
      type: 'payload.query',
      queryParameter: 'reason_type_id',
      selector: 'reasonTypeId',
    },
    {
      type: 'payload.query',
      queryParameter: 'location_ids',
      selector: 'locationIds',
    },
    {
      type: 'payload.query',
      queryParameter: 'date',
      selector: 'date',
    },
  ],
});

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case consts.SEND: {
      return {
        ...initialState,
        sending: true,
      };
    }

    case consts.SUCCEED: {
      return {
        ...state,
        data: payload,
        sending: false,
        succeed: true,
      };
    }

    case APPOINTMENT_PROGRESS_TYPES.SET_CARE_USER:
    case APPOINTMENT_PROGRESS_TYPES.CLEAR: {
      return initialState;
    }

    default: {
      return defaultRequestReducer(state, action);
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/available-eir-locations.js